var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import api from '@utils/axios';
import { externalFormTemplatesApiInternalFormLibraryTemplatesPath, backFlowFormTemplatesApiInternalFormLibraryTemplatesPath, gocanvasFormTemplatesApiInternalFormLibraryTemplatesPath } from '../../../routes';
const namespace = 'features.settings.form_library';
const useTemplates = (searchText, selectedState, apiPath) => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allStates, setAllStates] = useState([]);
    const getTemplates = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const res = yield api.get(apiPath);
            const fetchedTemplates = res.data.templates;
            setTemplates(fetchedTemplates);
            const statesSet = new Set();
            fetchedTemplates.forEach((t) => {
                if (t.state)
                    statesSet.add(t.state);
            });
            setAllStates(Array.from(statesSet).sort());
        }
        catch (error) {
            toast.error(translate('fetch_templates_error', { namespace }));
            setTemplates([]);
            setAllStates([]);
        }
        finally {
            setLoading(false);
        }
    });
    const removeTemplate = (template) => {
        setTemplates((prev) => prev.filter((t) => t.id !== template.id));
    };
    useEffect(() => {
        getTemplates();
    }, [apiPath]);
    const filteredTemplates = useMemo(() => {
        let filtered = templates;
        if (searchText.trim()) {
            const lowerSearch = searchText.toLowerCase();
            filtered = filtered.filter(({ displayName, country, state, city }) => (displayName === null || displayName === void 0 ? void 0 : displayName.toLowerCase().includes(lowerSearch)) ||
                (country === null || country === void 0 ? void 0 : country.toLowerCase().includes(lowerSearch)) ||
                (state === null || state === void 0 ? void 0 : state.toLowerCase().includes(lowerSearch)) ||
                (city === null || city === void 0 ? void 0 : city.toLowerCase().includes(lowerSearch)));
        }
        if (selectedState) {
            filtered = filtered.filter((t) => t.state === selectedState);
        }
        return filtered;
    }, [templates, searchText, selectedState]);
    return { templates: filteredTemplates, loading, removeTemplate, allStates };
};
export const useExternalFormTemplates = (searchText, selectedState) => useTemplates(searchText, selectedState, externalFormTemplatesApiInternalFormLibraryTemplatesPath({ format: 'json' }));
export const useBackFlowTypeTemplates = (searchText, selectedState) => useTemplates(searchText, selectedState, backFlowFormTemplatesApiInternalFormLibraryTemplatesPath({ format: 'json' }));
export const useGocanvasTemplates = (searchText) => useTemplates(searchText, '', gocanvasFormTemplatesApiInternalFormLibraryTemplatesPath({ format: 'json' }));
